import {
  Asset as AmbassadorAsset,
  Template as AmbassadorTemplate,
  Type as AssetType,
} from '@wix/ambassador-funnel-templates-gallery-v2-template/types';
import { BLANK_TEMPLATE_META_SITE_ID } from '../../config';

export interface Asset {
  absoluteUrl: string;
  alt: string;
  type: AssetType;
}

export interface Template {
  templateId: string;
  title: string;
  metaSiteId: string;
  description: string;
  slug: string;
  assets: Asset[];
  categoryId?: string;
}

export function mapAmbassadorAsset(asset: AmbassadorAsset): Asset {
  return {
    absoluteUrl: asset.absoluteUrl!,
    alt: asset.alt!,
    type: asset.type!,
  };
}

export function mapAmbassadorTemplate(template: AmbassadorTemplate): Template {
  return {
    templateId: template.templateId!,
    description: template.description!,
    title: template.title!,
    metaSiteId: template.metaSiteId!,
    slug: template.slug!,
    assets: template.assets?.map<Asset>(mapAmbassadorAsset) ?? [],
  };
}

export const isBlankTemplate = (template: Template) => {
  return template.metaSiteId === BLANK_TEMPLATE_META_SITE_ID;
};
